import React, { Component } from 'react';
import SaveButton from 'components/form/save-button';
import { inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

@withNamespaces()
@inject('store')
class CreateFamily extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
        };

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.preventDefault();

        this.setState({loading: true});
        this.props.store.family.requestCreateFamily()
            .catch(err => this.setState({loading: false}));
    }

    render() {
        const { loading } = this.state;

        return (
            <div className="card">
                <div className="card-body">
                    You don't have a family yet, please create one!
                    <br />
                    <SaveButton onClick={this.handleClick} text="Create Family" loading={loading} />
                </div>
            </div>
        )
    }
}

export default CreateFamily;


// WEBPACK FOOTER //
// ./src/modules/family/pages/manage/create-family.js